module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAgMAAAAog1vUAAAADFBMVEUAAAAjHyAjHyAjHyDrNp3xAAAABHRSTlMAgP8AwYKAaAAAAClJREFUeAFjGBJgFLCtAoP5/0GAAUz+ggitHwlCo0Lf0BMAAgw+oVEhALCaOYN6lvCGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/25aa.png
// module id = 1334
// module chunks = 0